module.exports = __webpack_public_path__ + "img/lafsaicon-1760-pagina-de-titlu-big.0010fa9a.jpg";